import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight, Play } from "lucide-react";

export const SignalHero = () => (
  <section id="top" data-testid="signal-hero" className="signal-hero">
    <img src={`${process.env.PUBLIC_URL}/hero-bg.webp`} alt="" aria-hidden="true" className="signal-hero-image" fetchPriority="high" draggable={false} />
    <div className="signal-hero-scrim" aria-hidden="true" />
    <div className="signal-container signal-hero-inner">
      <motion.div className="signal-hero-copy" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
        <p className="signal-eyebrow" data-testid="signal-hero-brand">Ivory Pulse introduces</p>
        <h1 data-testid="signal-hero-name">Pulse One</h1>
        <p className="signal-hero-position" data-testid="signal-hero-line">The world's first standalone AI voice assistant bracelet.</p>
        <p className="signal-hero-detail" data-testid="signal-hero-spec">Built-in eSIM + Wi-Fi.<br />Your phone can stay behind.</p>
        <div className="signal-hero-actions">
          <a href="#transmission" className="signal-button signal-button-light" data-testid="signal-hero-cta">Join the waitlist <ArrowUpRight size={18} aria-hidden="true" /></a>
          <a href="#voices" className="signal-text-link" data-testid="signal-hero-listen"><Play size={15} aria-hidden="true" /> Meet the voices</a>
        </div>
      </motion.div>
      <div className="signal-hero-bottom">
        <p data-testid="signal-hero-reveal">Design reveal <span>Coming soon</span></p>
        <p data-testid="signal-hero-edition">Pulse One <span>Founders Edition · 1,000 bracelets</span></p>
        <a href="#object" aria-label="Explore the bracelet" data-testid="signal-hero-explore"><ArrowDown size={20} aria-hidden="true" /></a>
      </div>
    </div>
  </section>
);